"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyPronunciationDefinitionsToVoiceOverText = exports.getSourcePronunciationRegex = void 0;
const getSourcePronunciationRegex = (source) => {
    const escapedSource = source.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    return new RegExp(`(\\W|^)(${escapedSource})(\\W|$)`, "gm");
};
exports.getSourcePronunciationRegex = getSourcePronunciationRegex;
const applyPronunciationDefinitionsToVoiceOverText = (text, definitions) => {
    for (const definition of definitions) {
        text = text.replace((0, exports.getSourcePronunciationRegex)(definition.source), `$1${definition.target}$3`);
    }
    return text;
};
exports.applyPronunciationDefinitionsToVoiceOverText = applyPronunciationDefinitionsToVoiceOverText;
//# sourceMappingURL=pronunciationUtils.js.map